import demoViewer from "./demo-viewer.vue";

const components = {
  demoViewer
};

export default Vue => {
  Object.keys(components).forEach(key => {
    Vue.component(key, components[key]);
  });
};
